import { render, staticRenderFns } from "./absenceStudentList.vue?vue&type=template&id=2cfa33d0&"
import script from "./absenceStudentList.vue?vue&type=script&lang=js&"
export * from "./absenceStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports